import { invoicePaymentStatusMap, invoiceTypeToTooltip } from "./InvoicesDigestWIdget.utils";
import { NavLink } from 'react-router-dom';
import styles from "./InvoicesDigestWidget.module.scss";
import { Tooltip } from 'seagull';
import pluralize from 'pluralize';
import { routes } from "../../../constants";
import React from 'react';
import { invoiceStatusToColor } from "./InvoicesDigestWidget";
import { utils } from "../../../utils";
const InvoiceBar = _ref => {
  let {
    invoicesDigest
  } = _ref;
  const paymentStatus = 'paymentStatus';
  return /*#__PURE__*/React.createElement("div", {
    className: styles.invoiceBarContent,
    "data-testid": "invoices-bar"
  }, invoicesDigest.percentages().map(_ref2 => {
    let {
      type,
      percentage,
      count,
      amount
    } = _ref2;
    return /*#__PURE__*/React.createElement(Tooltip, {
      key: type,
      title: /*#__PURE__*/React.createElement("div", {
        "data-testid": "invoice-bar-".concat(type, "-percentage-tooltip")
      }, utils.formatNumberWithCommas(count), " ", pluralize('invoice', count), " totaling", ' ', amount.display(), " ", invoiceTypeToTooltip(count)[type])
    }, /*#__PURE__*/React.createElement(NavLink, {
      style: {
        width: "".concat(percentage, "%"),
        backgroundColor: invoiceStatusToColor[type]
      },
      to: "".concat(routes.invoicesDashboard, "?").concat(paymentStatus, "=").concat(invoicePaymentStatusMap[type]),
      "data-testid": "invoice-bar-".concat(type, "-percentage"),
      className: styles.invoiceBarPercentage
    }));
  }));
};
export default InvoiceBar;